import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function OAuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // The @lovable.dev/cloud-auth-js library handles the token exchange
    // via the /~oauth route automatically. After processing, redirect home.
    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin mx-auto text-muted-foreground" />
        <p className="font-sans text-sm text-muted-foreground">Completing sign-in…</p>
      </div>
    </div>
  );
}
